import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {
  Grid,
  styled,
  tableCellClasses,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import moment from "moment/moment";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.headerWhite.main,
    border: "none",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

function StudentHistory({
  studentDetails,
  studentName,
  studentAuid,
  loading = false,
}) {
  return (
    <>
      <Box
        sx={{
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          overflow: "hidden",
          mb: 2,
        }}
      >
        <Box
          sx={{
            backgroundColor: "tableBg.main",
            color: "tableBg.textColor",
            textAlign: "center",
            p: 1,
            fontWeight: 500,
            fontSize: "14px",
          }}
        >
          <Typography variant="subtitle2">Student Details</Typography>
        </Box>
        <Table size="small">
          <TableBody>
            <TableRow>
              <TableCell sx={{ fontWeight: 600 }}>Student Name</TableCell>
              <TableCell>
                <span>:</span>
                <span style={{ marginLeft: "15px" }}>
                  {studentName || studentDetails?.[0]?.emp_name || "-"}
                </span>
              </TableCell>
              {studentAuid && (
                <>
                  <TableCell sx={{ fontWeight: 600 }}>AUID</TableCell>
                  <TableCell>
                    <span>:</span>
                    <span style={{ marginLeft: "15px" }}>{studentAuid}</span>
                  </TableCell>
                </>
              )}
            </TableRow>
          </TableBody>
        </Table>
      </Box>
      <Grid item xs={12} mt={3}>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <StyledTableCell sx={{ color: "white" }}>SL.No</StyledTableCell>
                <StyledTableCell sx={{ color: "white" }}>
                  Employee Name
                </StyledTableCell>
                <StyledTableCell sx={{ color: "white" }}>
                  Employee Code
                </StyledTableCell>
                <StyledTableCell sx={{ color: "white" }}>
                  Assigned Date
                </StyledTableCell>
                <StyledTableCell sx={{ color: "white" }}>
                  Assigned Username
                </StyledTableCell>
                <StyledTableCell sx={{ color: "white" }}>
                  Deassign Date
                </StyledTableCell>
                <StyledTableCell sx={{ color: "white" }}>
                  Deassign Username
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <StyledTableCell colSpan={7} align="center">
                    <CircularProgress size={24} sx={{ my: 2 }} />
                  </StyledTableCell>
                </TableRow>
              ) : studentDetails && studentDetails.length > 0 ? (
                studentDetails.map((val, i) => (
                  <TableRow key={i}>
                    <StyledTableCell>{i + 1}</StyledTableCell>
                    <StyledTableCell>{val.emp_name}</StyledTableCell>
                    <StyledTableCell>{val.emp_code}</StyledTableCell>
                    <StyledTableCell>
                      {val.assigned_date
                        ? moment(val.assigned_date).format("DD-MM-YYYY HH:mm")
                        : "-"}
                    </StyledTableCell>
                    <StyledTableCell>
                      {val.assigned_username || "-"}
                    </StyledTableCell>
                    <StyledTableCell>
                      {val.deassign_date
                        ? moment(val.deassign_date).format("DD-MM-YYYY HH:mm")
                        : "-"}
                    </StyledTableCell>
                    <StyledTableCell>
                      {val.deassign_username || "-"}
                    </StyledTableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <StyledTableCell colSpan={7} align="center">
                    No data available
                  </StyledTableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </>
  );
}
export default StudentHistory;
